import React from 'react';
import { Autocomplete, TextField, LocationOn, Replay } from '@mui/material';

import useTripReport from './useTripReport';
import ReportLayoutPage from '../ReportLayoutPage';
import PeriodSelector from 'components/common/PeriodSelector';
import ReportShowButton from '../ReportShowButton';
import FileExportReportButtons from '../FileExportReportButtons';
import { sortByThenBy } from 'utils/sort';
import ItemRow from 'components/common/ItemRow';
import ItemTable from 'components/home/ItemTable';

const TripReportPage = () => {
    const { 
        formatDeviceCategory,
        t,
        globalClasses,
        loading, 
        devices,
        deviceId,
        updateDeviceId: setDeviceId,
        period, 
        setPeriod,
        from,
        setFrom,
        to,
        setTo,
        handleSubmit,
        tasks,
        getFiltersKey,
        displayDisabled,
        pdfDisabled,
        excelDisabled,
        emailDisabled,
        staffersOptions,
        stafferId, 
        updateStafferId: setStafferId,
        ...rest
    } = useTripReport();

    return (
        <ReportLayoutPage 
            loading={loading}
            filter={
                <div className={globalClasses.rootReportEngineContainer}>
                    <div className={globalClasses.reportFiltersContainer}>
                        <Autocomplete
                            key={deviceId || Math.random()}
                            options={devices.sort((deviceA, deviceB) => sortByThenBy(deviceA.category, deviceA.name.toLowerCase(), deviceB.category, deviceB.name.toLowerCase()))}
                            groupBy={d => formatDeviceCategory(d?.category)}
                            getOptionLabel={d => d?.name || ''}
                            value={devices.find(d => d.id === deviceId)}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            onChange={(_, value) => setDeviceId(value?.id || null)}
                            renderInput={(params) => <TextField {...params} label={t('reportDevice')} variant='outlined'/>}
                        />
                        <Autocomplete 
                            key={stafferId || Math.random()}
                            options={staffersOptions}
                            getOptionLabel={s => `${s?.firstname} ${s?.name}`}
                            value={staffersOptions.find(s => s.id === stafferId)}
                            onChange={(_, value) => setStafferId(value?.id || null)}
                            renderInput={(params) => <TextField {...params} label={t('stafferName')} variant='outlined'/>}
                        />
                        <PeriodSelector 
                            period={period} 
                            setPeriod={setPeriod} 
                            from={from}
                            setFrom={setFrom}
                            to={to}
                            setTo={setTo}
                        />
                        <ReportShowButton
                            disabled={displayDisabled}
                            handleSubmit={handleSubmit}
                        />
                    </div>
                    <div className={globalClasses.reportButtonsContainer}>
                        <FileExportReportButtons
                            pdfDisabled={pdfDisabled}
                            excelDisabled={excelDisabled}
                            emailDisabled={emailDisabled}
                            tasks={tasks}
                            handleSubmit={handleSubmit}
                            getFiltersKey={getFiltersKey}
                        />
                    </div>
                </div>
            }
        >
            <ItemTable
                {...rest}
                getRowId={row => row.startPositionId}
            >
                { ({ itemRow, ...rest }) => (
                    <ItemRow 
                        key={itemRow.startPositionId} 
                        itemRow={itemRow}
                        {...rest}
                    />
                )}
            </ItemTable>
        </ReportLayoutPage>
    );
}

export default TripReportPage;
